module.exports = __webpack_public_path__ + "img/01.3cbc1363.jpg";